import Fld from './fld';
import './style.css';

const Flds = (props) => {
	let cls = ['skin-flds', 'flds'];
	cls = cls.join(' ');
	return (
		<div className={cls}>
			<Fld
				label="Наименование площадки"
				name="market"
				id="market"
				// pict="/skin/img/login_password.svg"
				type="text"
				holder="Введите наименование площадки"
				required="true"
			/>
			<Fld
				label="Логин"
				name="login"
				id="login"
				pict="/skin/img/login_user.svg"
				holder="Введите логин"
				required="true"
			/>
			<Fld
				label="Пароль"
				name="password1"
				id="password1"
				pict="/skin/img/login_password.svg"
				type="password"
				holder="Введите пароль от 8 до 16 символов"
				minlength="8"
				maxlength="16"
				required="true"
			/>

			<Fld
				label="Повторите пароль"
				name="password2"
				id="password2"
				pict="/skin/img/login_password.svg"
				type="password"
				holder="Введите пароль от 8 до 16 символов"
				minlength="8"
				maxlength="16"
				required="true"
			/>
		</div>
	);
};

export default Flds;
